import Space from 'redux/models/Space';

import warehouse from 'services/warehouse';

export const UPDATE_PROFILE = {
  FAILURE: 'UPDATING_PROFILE_FAILED',
  REQUEST: 'UPDATING_PROFILE',
  SUCCESS: 'UPDATED_PROFILE'
};

const UPDATE_SHOW_EMAIL_VERIFICATION_NOTICE = 'UPDATE_SHOW_EMAIL_VERIFICATION_NOTICE';
const UPDATE_SHOW_EMAIL_VERIFIED_NOTICE = 'UPDATE_SHOW_EMAIL_VERIFIED_NOTICE';
const UPDATE_SHOW_ACCOUNT_ERROR_NOTICE = 'UPDATE_SHOW_ACCOUNT_ERROR_NOTICE';
const UPDATE_SPACELIST = 'UPDATE_SPACELIST';
const SET_SHOW_LOADER = 'SET_SHOW_LOADER';

const initialState = {
  showEmailVerificationNotice: false,
  showEmailVerifiedNotice: false,
  showAccountErrorNotice: false,
  accountErrorMessage: '',
  spaces: [],
  showLoader: false
};

export const reducerKey = 'accountSettings';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SHOW_EMAIL_VERIFICATION_NOTICE:
      return {
        ...state,
        showEmailVerificationNotice: action.payload
      };
    case UPDATE_SHOW_EMAIL_VERIFIED_NOTICE:
      return {
        ...state,
        showEmailVerifiedNotice: action.payload
      };
    case UPDATE_SHOW_ACCOUNT_ERROR_NOTICE:
      return {
        ...state,
        showAccountErrorNotice: action.payload
      };
    case UPDATE_PROFILE.FAILURE:
      return {
        ...state,
        showAccountErrorNotice: true,
        accountErrorMessage: action.reason
      };
    case UPDATE_SPACELIST:
      return {
        ...state,
        spaces: action.payload
      };
    case SET_SHOW_LOADER:
      return {
        ...state,
        showLoader: action.payload
      };
    default:
      return state;
  }
};

export const updateProfile = data => ({
  type: UPDATE_PROFILE.REQUEST,
  payload: data
});

export const updateShowEmailVerificationNotice = bool => ({
  type: UPDATE_SHOW_EMAIL_VERIFICATION_NOTICE,
  payload: bool
});

export const updateShowEmailVerifiedNotice = bool => ({
  type: UPDATE_SHOW_EMAIL_VERIFIED_NOTICE,
  payload: bool
});

export const updateShowAccountErrorNotice = bool => ({
  type: UPDATE_SHOW_ACCOUNT_ERROR_NOTICE,
  payload: bool
});

export const getSpaceList = (userId) => (dispatch) => {
  warehouse.getStudioSpacesFor({ userId }).then(response => {
    const spaces = response.results.map(whSpace => {
      return Space.createSpaceFromWarehouseResponse({whSpace});
    }).filter(space => !space.isPrePurchase());

    dispatch({
      type: UPDATE_SPACELIST,
      payload: spaces
    });
  });
};

export const setShowLoader = bool => (dispatch) => {
  dispatch({
    type: SET_SHOW_LOADER,
    payload: bool
  });
};

const extractState = state => state[reducerKey];

export const getAllSpaces = (state) => {
  return extractState(state).spaces;
};

export const getShowEmailVerificationNotice = (state) => {
  return extractState(state).showEmailVerificationNotice;
};

export const getShowEmailVerifiedNotice = (state) => {
  return extractState(state).showEmailVerifiedNotice;
};

export const getShowAccountErrorNotice = (state) => {
  return extractState(state).showAccountErrorNotice;
};

export const getShowLoader = (state) => {
  return extractState(state).showloader;
};

export const getAccountErrorMessage = (state) => {
  return extractState(state).accountErrorMessage;
};
